// Crypto-free auth helpers.
//
// These functions do NOT depend on crypto-js. They are split out of authHelper.ts
// so that consumers which only need machine-id / cookie / logout helpers (e.g.
// user.service, gladiator.service, and — transitively — the Redux store bundled
// into _app) don't drag the ~50KB crypto-js (+ buffer/get-intrinsic) into their
// chunk just because it shares a module with the AES-based storeAuth/getAuth.
//
// The AES-based storeAuth/getAuth remain in authHelper.ts, which re-exports
// everything here so the existing `@jobseeker/common-core/utils/authHelper`
// public API is unchanged.
import {deleteCookie, getCookie} from 'cookies-next';
import {v7 as uuidv7} from 'uuid';
import {
  AUTH_TOKEN,
  COOKIE_LOGIN_AUTH,
  OBS_ID,
} from '@jobseeker/common-core/constants';

const storeObsId = (id: string) => {
  localStorage.setItem(OBS_ID, id);
};

const getObsId = () => {
  return localStorage.getItem(OBS_ID);
};

const clearAuth = (): void => {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(OBS_ID);
  deleteCookie('filter');
  localStorage.removeItem('filter');
  if (
    process.env.NEXT_PUBLIC_FILTER_CAT_TAG === 'true' &&
    process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs'
  ) {
    deleteCookie('filterCat');
    localStorage.removeItem('filterCat');
  }
};

const checkLoginCookieExist = (): string => {
  const cookie = getCookie(COOKIE_LOGIN_AUTH, {
    domain:
      process.env.NEXT_PUBLIC_TRAIL === 'true'
        ? 'localhost'
        : process.env.NEXT_PUBLIC_DOMAIN,
  });

  if (cookie && typeof cookie === 'string') {
    const parts = cookie.split('.');
    if (parts && parts.length === 3) {
      return cookie;
    }
    return '';
  }
  return '';
};

const getMachineId = () => {
  let machineId = localStorage.getItem('MachineId');
  if (!machineId) {
    machineId = uuidv7();
    localStorage.setItem('MachineId', machineId);
  }

  return machineId;
};

export {storeObsId, getObsId, clearAuth, checkLoginCookieExist, getMachineId};
